import React from "react";
import { useAuth } from "react-oidc-context";
import logo from "../../assets/lm-logo-blue.svg";


import "./style.scss";

const Login = () => {
  const auth = useAuth();
  const onLoginButtonClick = (e) => {
    e.preventDefault();
    auth.signinRedirect();
  };

  return (
<div className="login-page">
<div className="login-interface">
  <img className="login-logo" src={logo} alt="login image" />
  <div className="login-title">Locate & Mark</div>
  <div className="login-version">
    Build: {process.env.REACT_APP_VERSION.substring(0, 7) || "N/A"}
  </div>
  <button
    className="login-button"
    type="button"
    onClick={(e) => onLoginButtonClick(e)}
  >
    Log in
  </button>
</div>
</div>

  );
};

export default Login;
